import React, { useState } from 'react';
import { Modal, Box, Typography, Button } from '@mui/material';
import AdsClickIcon from '@mui/icons-material/AdsClick';

const FormModal = ({
  title,
  form,
  buttonName = 'Open Modal',
  startIcon,
  buttonVariant,
  buttonSx,
  allowIcon = true,
  width = 400,
  height = 'auto',
  useSpan = false,
  onOpen,
}) => {
  // State to control modal visibility
  const [isVisible, setIsVisible] = useState(false);

  // Function to open the modal
  const handleOpen = () => {
    // console.log("Modal opened")
    setIsVisible(true);
    if (onOpen) {
      onOpen();
    }
  };

  // Function to close the modal
  const handleClose = () => {
    setIsVisible(false);
  };

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: width,
    height: height,
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
    borderRadius: 2,
    maxHeight: '90vh',
    overflow: 'auto',
  };

  return (
    <div>
      {/* Button to trigger the modal */}
      {allowIcon ? (
        <Button
          variant={buttonVariant ?? 'contained'}
          onClick={handleOpen}
          startIcon={startIcon ?? <AdsClickIcon />}
          sx={buttonSx}
        >
          {buttonName}
        </Button>
      ) : useSpan ? (
        <span onClick={handleOpen} style={{ cursor: 'pointer' }}>
          {buttonName}
        </span>
      ) : (
        <Button variant={buttonVariant ?? 'contained'} onClick={handleOpen} sx={buttonSx}>
          {buttonName}
        </Button>
      )}

      {/* Modal */}
      <Modal
        open={isVisible}
        onClose={handleClose}
        keepMounted={false}
        disableAutoFocus={true}
        disableEnforceFocus={true}
      >
        <Box sx={style}>
          {title && (
            <Typography variant="h6" component="h2" sx={{ mb: 2 }}>
              {title}
            </Typography>
          )}
          {/* Render the form passed as a prop */}
          {React.cloneElement(form, { closeModal: handleClose })}
        </Box>
      </Modal>
    </div>
  );
};

export default FormModal;
